import { React, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NIDS.css';

const NIDSReport = () => {
  const heroRef = useRef(null);

  const handleStartReport = () => {
    window.scrollTo({
      top: window.pageYOffset + window.innerHeight * 0.9, 
      behavior: 'smooth',
    });
  };

  return (
    <div>
      <section ref={heroRef} className="hero d-flex align-items-center justify-content-center">
        <div className="text-center">
          <h1 className="display-2 mb-4" style={{ width: '60%', margin: 'auto' }}>
            Network Intrusion <strong  style={{color:'#B89CFC'}}>Detection</strong> System (NIDS)
          </h1>
          
          <h2 className="h3 mb-4">A Comprehensive Project Report</h2>
          <p className="lead mb-5">Real-time detection of threats for secure networks</p>

          <button class="btn"onClick={handleStartReport}>
                <span class="btn-text-one">Start Report</span>
                <span class="btn-text-two"><i className="fas fa-arrow-down ms-2"></i></span>
            </button>
        </div>
      </section>
    </div>
  );
};

export default NIDSReport;
